import { AppDispatchType, RootState } from "../store/redux-store/root_store";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

export const useDispatcher: () => AppDispatchType = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
